import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav container" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("走进华科")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("公司简介")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("单位沿革")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("公司资质")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("公司荣誉")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("公司文化")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("人才队伍")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("最新动态")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("环境要闻")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("公司新闻")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("党群动态")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("公示公告")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("公司业绩")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("工程设计与总包")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("环保咨询")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("装备与信息化")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("典型案例")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("加入我们")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("联系我们")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("招贤纳士")
const _hoisted_24 = { class: "menu-vertical-mask" }
const _hoisted_25 = { class: "menu-window-container" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("走进华科")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("公司简介")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("单位沿革")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("公司资质")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("公司文化")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("最新动态")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("环境要闻")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("公司新闻")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("党群动态")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("公示公告")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("公司业绩")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("工程设计与总包")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("环保咨询")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("装备与信息化")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("典型案例")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("加入我们")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("联系我们")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("招贤纳士")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_menu, {
        "default-active": _ctx.activeIndex,
        class: "el-menu-demo",
        mode: "horizontal",
        ellipsis: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "home" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/home" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "approach" }, {
            title: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "desc" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/desc" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "evolution" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/evolution" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "certification" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/certification" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "honor" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/honor" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "companyCulture" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/companyCulture" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "talent" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/approach/talent" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "news" }, {
            title: _withCtx(() => [
              _hoisted_11
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "enNews" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/news/enNews" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "cpNews" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/news/cpNews" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "partyNews" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/news/partyNews" }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "bulletin" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/news/bulletin" }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "achievement" }, {
            title: _withCtx(() => [
              _hoisted_16
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "projects" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/projects" }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/consult" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/consult" }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "equipment" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/equipment" }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, { index: "case" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/case" }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_sub_menu, { index: "joinIn" }, {
            title: _withCtx(() => [
              _hoisted_21
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "contact" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/join-in/contact" }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "humanResources" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/join-in/human-resources" }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_el_menu, {
          "default-active": _ctx.activeIndex,
          class: "el-menu-demo",
          "active-text-color": "#0C7ED9",
          mode: "vertical",
          ellipsis: false,
          "unique-opened": true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "home" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/home" }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "approach" }, {
              title: _withCtx(() => [
                _hoisted_27
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "desc" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/approach/desc" }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "evolution" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/approach/evolution" }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "certification" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/approach/certification" }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "companyCulture" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/approach/companyCulture" }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "news" }, {
              title: _withCtx(() => [
                _hoisted_32
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "enNews" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/news/enNews" }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "cpNews" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/news/cpNews" }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "partyNews" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/news/partyNews" }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "bulletin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/news/bulletin" }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "achievement" }, {
              title: _withCtx(() => [
                _hoisted_37
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "projects" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/projects" }, {
                      default: _withCtx(() => [
                        _hoisted_38
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/consult" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/consult" }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "equipment" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/equipment" }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "case" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: "/case" }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "joinIn" }, {
              title: _withCtx(() => [
                _hoisted_42
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "contact" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/join-in/contact" }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "humanResources" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: "/join-in/human-resources" }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ])
    ])
  ]))
}